<template>
  <div class="school-camps">
    <div class="school-camps__header">
      <h3>{{ i18n[locale].title }}</h3>
      <button class="do-bttn" @click="openCreateModal">{{ i18n[locale].create }}</button>
    </div>

    <Loader v-if="isLoading" color="blue"></Loader>

    <table class="do-table do-table--striped" v-else>
      <thead>
        <tr>
          <th>{{ i18n[locale].camp_title }}</th>
          <th>{{ i18n[locale].classes }}</th>
          <th>{{ i18n[locale].from_date }}</th>
          <th>{{ i18n[locale].to_date }}</th>
          <th class="th-hours">{{ i18n[locale].teaching_hours }}</th>
          <th class="th-hours">{{ i18n[locale].remaining_hours }}</th>
          <th>{{ i18n[locale].users }}</th>
          <th class="th-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="camps.length === 0">
          <td colspan="8" class="school-camps__empty">{{ i18n[locale].no_camps }}</td>
        </tr>
        <tr v-for="camp in camps" :key="camp.id" @click="openEditModal(camp)" class="camp-row">
          <td class="td-title">{{ camp.title }}</td>
          <td class="td-calendars">{{ getCalendarNamesByType(camp.calendar_ids, 'klass') }}</td>
          <td class="td-datetime">{{ formatDateTime(camp.from_time) }}</td>
          <td class="td-datetime">{{ formatDateTime(camp.to_time) }}</td>
          <td class="td-hours">{{ camp.teaching_hours != null ? parseFloat(camp.teaching_hours.toFixed(2)) : '' }}</td>
          <td class="td-hours">{{ camp.remaining_hours != null ? parseFloat(camp.remaining_hours.toFixed(2)) : '' }}</td>
          <td class="td-calendars">{{ getCalendarNamesByType(camp.calendar_ids, 'user') }}</td>
          <td class="td-actions" @click.stop>
            <button class="do-bttn do-bttn--small" @click="openEditModal(camp)">
              <span class="icon-pencil"></span>
            </button>
            <button class="do-bttn do-bttn--small do-bttn--danger" @click="theDeleteCamp = camp">
              <span class="icon-bin"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="camp-create text-dark" v-if="isModal">
      <DModal @close="closeModal" :show-close="false" :placeInTop="true">
        <div class="camp-create__modal" slot="insertComponent">
          <div class="camp-create__header">
            <h3>
              <span v-if="!theEditCamp">{{ i18n[locale].create }}</span>
              <span v-else>{{ form.title }}</span>
            </h3>
            <div class="camp-create__close icon__bg-circle" @click="closeModal">
              <span class="icon-cross2"></span>
            </div>
          </div>
          <form class="camp-create__body" @submit.prevent>
            <div class="camp-create__grid">
              <div class="camp-create__form">
                <div class="input-group">
                  <label>{{ i18n[locale].camp_title }}</label>
                  <input type="text"
                         class="d-input"
                         v-model="form.title"
                         :placeholder="i18n[locale].title_placeholder"
                         ref="titleInput">
                </div>
                <div class="input-group">
                  <label><span class="icon-list2"></span> {{ i18n[locale].add_classes }}</label>
                  <DSelectCalendarIds itemType="klass"
                                      :preSelectedItems="form.klassCalendarIds"
                                      @update="setSelectedKlasses">
                  </DSelectCalendarIds>
                </div>
                <div class="input-group">
                  <label><span class="icon-user"></span> {{ i18n[locale].add_users }}</label>
                  <DSelectCalendarIds itemType="USER"
                                      :preSelectedItems="form.userCalendarIds"
                                      :showTags="true"
                                      @update="setSelectedUsers">
                  </DSelectCalendarIds>
                </div>
                <div class="date-time-input-group">
                  <label>{{ i18n[locale].from_date }}</label>
                  <div class="date-time-row">
                    <div class="date-field date-time-row__date">
                      <DateSelector
                        :date="form.fromTime"
                        :width100="true"
                        :minDate="schoolYearMinDate"
                        :maxDate="schoolYearMaxDate"
                        @changed="onFromDateChanged">
                      </DateSelector>
                    </div>
                    <div class="input-with-icon">
                      <div class="icon icon-clock"></div>
                      <time-input
                        :date="form.fromTime"
                        @changed="onStartTimeInput">
                      </time-input>
                    </div>
                  </div>
                </div>
                <div class="date-time-input-group">
                  <label>{{ i18n[locale].to_date }}</label>
                  <div class="date-time-row">
                    <div class="date-field date-time-row__date">
                      <DateSelector
                        :date="form.toTime"
                        :width100="true"
                        :minDate="schoolYearMinDate"
                        :maxDate="schoolYearMaxDate"
                        @changed="onToDateChanged">
                      </DateSelector>
                    </div>
                    <div class="input-with-icon">
                      <div class="icon icon-clock"></div>
                      <time-input
                        :date="form.toTime"
                        @changed="onEndTimeInput">
                      </time-input>
                    </div>
                  </div>
                </div>
                <div class="input-group marg-1-top">
                  <label>{{ i18n[locale].available_time }}</label>
                  <div class="camp-toggle">
                    <div class="camp-toggle__option"
                         :class="{ 'camp-toggle__option--selected': form.useAdditionalTasks }"
                         @click="form.useAdditionalTasks = true">
                      <input type="radio"
                             :checked="form.useAdditionalTasks"
                             name="use_additional_tasks">
                             <p class="camp-toggle__option-text">
                              <span class="bold">Indregnes i arbejdstiden (1/3) som øvrig opgave</span>
                              <span>{{ i18n[locale].add_to_tasks }}</span>
                            </p>
                    </div>
                    <div class="camp-toggle__option"
                         :class="{ 'camp-toggle__option--selected': !form.useAdditionalTasks }"
                         @click="form.useAdditionalTasks = false">
                      <input type="radio"
                             :checked="!form.useAdditionalTasks"
                             name="use_additional_tasks">
                             <p class="camp-toggle__option-text">
                              <span class="bold">Udbetales som engangsydelse</span>
                             <span>{{ i18n[locale].pay_out }}</span>
                            </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="camp-create__sidebar" v-if="selectedUsers.length > 0">
                <div class="camp-create__sidebar-desc">
                  <h3>{{ i18n[locale].existing_hours }}</h3>
                  <p>{{ i18n[locale].existing_hours_desc }}</p>
                </div>
                <table class="do-table do-table--striped">
                  <thead>
                    <tr>
                      <th>{{ i18n[locale].person }}</th>
                      <th class="td-number">{{ i18n[locale].in_schedule }}</th>
                      <th class="th-hours">{{ i18n[locale].hours_label }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in selectedUsers" :key="user.id">
                      <td>{{ user.name }}</td>
                      <td class="td-number">
                        {{ formatMinutesToHours(scheduledHours[user.id]) }}t
                      </td>
                      <td class="td-hours">
                        <input type="number"
                               class="d-input td-hours__input"
                               v-model.number="form.existingHours[user.id]"
                               placeholder="0"
                               min="0"
                               step="any"
                               @focus="$event.target.select()">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="input-group input-group__submit marg-1-top">
              <div class="input-group__submit__left">
                <template v-if="theEditCamp">
                  <button class="bttn--warning"
                          @click="theDeleteCamp = theEditCamp">
                    <span class="icon-bin"></span>
                  </button>
                </template>
                <a class="camp-create__guide"
                   href="https://app.docendo.dk/app#/helpdesk?article=239"
                   target="_blank">
                  <span class="icon-question3"></span>
                  {{ i18n[locale].guide }}
                </a>
              </div>
              <div class="input-group__submit__right">
                <button class="marg-1-right do-bttn" @click="closeModal">{{ i18n[locale].cancel }}</button>
                <button class="do-bttn do-bttn--submit"
                        :class="{'do-bttn--submit--loading': isSaving}"
                        :disabled="!isFormValid"
                        @click="saveCamp">
                  {{ theEditCamp ? i18n[locale].save : i18n[locale].create }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </DModal>
      <div class="bg-overlay animatedFast fadeIn"></div>
    </div>

    <ModalConfirmation
      v-if="theDeleteCamp"
      @close="theDeleteCamp = null"
      @confirm="deleteCamp"
      :showClose="false"
      :isSubmitButtonLoading="isDeleting">
    </ModalConfirmation>
  </div>
</template>

<script>
import DModal from '../common/DModal'
import DSelectCalendarIds from '../DSelect/DSelectCalsIds'
import ModalConfirmation from '../Modals/ModalConfirmation'
import Loader from '../common/Loader.vue'
import DateSelector from '../datepicker/DateSelector.vue'
import TimeInput from '../timechanger/TimeInput.vue'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import moment from 'moment'

const I18N = {
  da: {
    title: 'Lejrskoler',
    guide: 'Guide til lejrskole udregning',
    create: 'Opret lejrskole',
    edit: 'Rediger lejrskole',
    camp_title: 'Titel',
    title_placeholder: 'F.eks. Lejrskole 5. klasse',
    from_date: 'Afrejse',
    to_date: 'Hjemkomst',
    time: 'Tid',
    period: 'Periode',
    classes: 'Klasser',
    add_classes: 'Tilføj klasser',
    add_users: 'Tilføj personer',
    users: 'Personer',
    existing_hours: 'Angiv UV-reduktion',
    existing_hours_desc: 'Angiv det antal UV-timer som hver person allerede har i skema i lejrskoleperioden. Disse timer trækkes fra, da de vil blive aflyst eller vikardækket. Hvis skemaet endnu ikke er lagt, kan et forventet tal skrives ind, og evt. opdateres senere.',
    hours_label: 'Reduktion',
    person: 'Person',
    in_schedule: 'I skema',
    available_time: 'Hvordan skal rådighedstjenesten håndteres?',
    pay_out: 'Rådighedstjenesten skal I selv oprette som engangsydelse',
    add_to_tasks: 'Rådighedstjenesten oprettes automatisk som øvrig opgave med 1/3 af tiden',
    teaching_hours: 'UV-timer',
    remaining_hours: 'Øvrig tid',
    no_camps: 'Ingen lejrskoler oprettet',
    cancel: 'Annuller',
    save: 'Gem',
    created: 'Lejrskole oprettet',
    updated: 'Lejrskole opdateret',
    deleted: 'Lejrskole slettet',
    something_went_wrong: 'Noget gik galt'
  },
  en: {
    title: 'School camps',
    guide: 'Guide to camp hour calculation',
    create: 'Create school camp',
    edit: 'Edit school camp',
    camp_title: 'Title',
    title_placeholder: 'E.g. School camp 5th grade',
    from_date: 'From date',
    to_date: 'To date',
    time: 'Time',
    period: 'Period',
    classes: 'Classes',
    add_classes: 'Add classes',
    add_users: 'Add people',
    users: 'People',
    existing_hours: 'Reduction',
    existing_hours_desc: 'Enter the number of hours each person already has scheduled during the camp period. These hours will be deducted as they will be cancelled or covered by a substitute. If the schedule has not been finalised yet, the number can be updated later.',
    hours_label: 'Hours',
    person: 'Person',
    in_schedule: 'Scheduled',
    available_time: 'How should standby duty be handled?',
    pay_out: 'Paid out as a one-time payment',
    add_to_tasks: 'Included in working hours (1/3) as additional task',
    teaching_hours: 'Teaching hours',
    remaining_hours: 'Remaining hours',
    no_camps: 'No school camps created',
    cancel: 'Cancel',
    save: 'Save',
    created: 'School camp created',
    updated: 'School camp updated',
    deleted: 'School camp deleted',
    something_went_wrong: 'Something went wrong'
  },
  nb: {
    title: 'Leirskoler',
    guide: 'Guide til leirskole beregning',
    create: 'Opprett leirskole',
    edit: 'Rediger leirskole',
    camp_title: 'Tittel',
    title_placeholder: 'F.eks. Leirskole 5. klasse',
    from_date: 'Fra dato',
    to_date: 'Til dato',
    time: 'Tid',
    period: 'Periode',
    classes: 'Klasser',
    add_classes: 'Legg til klasser',
    add_users: 'Legg til personer',
    users: 'Personer',
    existing_hours: 'Reduksjon',
    existing_hours_desc: 'Angi antall timer hver person allerede har i timeplanen i leirskoleperioden. Disse timene trekkes fra, da de vil bli avlyst eller vikardekket. Hvis timeplanen ikke er lagt ennå, kan tallet oppdateres senere.',
    hours_label: 'Timer',
    person: 'Person',
    in_schedule: 'I timeplan',
    available_time: 'Hvordan skal beredskapstjenesten håndteres?',
    pay_out: 'Utbetales som engangsytelse',
    add_to_tasks: 'Innregnes i arbeidstiden (1/3) som øvrig oppgave',
    teaching_hours: 'UV-timer',
    remaining_hours: 'Øvrig tid',
    no_camps: 'Ingen leirskoler opprettet',
    cancel: 'Avbryt',
    save: 'Lagre',
    created: 'Leirskole opprettet',
    updated: 'Leirskole oppdatert',
    deleted: 'Leirskole slettet',
    something_went_wrong: 'Noe gikk galt'
  }
}

export default {
  components: {
    DModal,
    DSelectCalendarIds,
    ModalConfirmation,
    Loader,
    DateSelector,
    TimeInput
  },
  data () {
    return {
      camps: [],
      isLoading: false,
      isModal: false,
      isSaving: false,
      isDeleting: false,
      theEditCamp: null,
      theDeleteCamp: null,
      form: {
        title: 'Lejrskole',
        fromTime: moment().startOf('isoWeek').add(1, 'week').set({ hour: 6, minute: 0 }),
        toTime: moment().startOf('isoWeek').add(1, 'week').add(4, 'days').set({ hour: 16, minute: 0 }),
        klassCalendarIds: [],
        userCalendarIds: [],
        existingHours: {},
        useAdditionalTasks: true
      },
      scheduledHours: {}
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    schoolYearMinDate () {
      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_start) {
        return moment(this.activeSchoolYear.employee_time_start)
      }
      return null
    },
    schoolYearMaxDate () {
      if (this.activeSchoolYear && this.activeSchoolYear.employee_time_end) {
        return moment(this.activeSchoolYear.employee_time_end)
      }
      return null
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    isFormValid () {
      return this.form.title.trim().length > 0
    },
    selectedUsers () {
      return this.form.userCalendarIds
        .map(id => this.allCalendarsInHash[id])
        .filter(cal => cal)
    }
  },
  watch: {
    activeSchoolYear () {
      this.readCamps()
    }
  },
  methods: {
    readCamps () {
      if (!this.activeSchoolYear || !this.activeSchoolYear.id) return
      this.isLoading = true
      docendo.schoolCampsList(this.schoolId, this.activeSchoolYear.id, data => {
        this.camps = data
        this.isLoading = false
      }, () => {
        eventbus.toast = { text: this.i18n[this.locale].something_went_wrong, success: false }
        this.isLoading = false
      })
    },
    formatDate (dateStr) {
      if (!dateStr) return ''
      return moment(dateStr).format('D. MMM YYYY')
    },
    formatDateTime (dateStr) {
      if (!dateStr) return ''
      return moment(dateStr).format('D. MMM YYYY [kl.] HH:mm')
    },
    formatTime (dateStr) {
      if (!dateStr) return ''
      return moment(dateStr).format('HH:mm')
    },
    getCalendarNamesByType (calendarIds, type) {
      if (!calendarIds || calendarIds.length < 1) return ''
      return calendarIds
        .filter(id => {
          const cal = this.allCalendarsInHash[id]
          return cal && cal.type === type
        })
        .map(id => this.allCalendarsInHash[id].name)
        .filter(name => name && name.length > 0)
        .join(', ')
    },
    clampDateToSchoolYear (date) {
      if (this.schoolYearMinDate && date.isBefore(this.schoolYearMinDate)) {
        return moment(this.schoolYearMinDate).set({ hour: date.hours(), minute: date.minutes() })
      }
      if (this.schoolYearMaxDate && date.isAfter(this.schoolYearMaxDate)) {
        return moment(this.schoolYearMaxDate).set({ hour: date.hours(), minute: date.minutes() })
      }
      return date
    },
    openCreateModal () {
      this.theEditCamp = null
      this.scheduledHours = {}
      let firstMonday = this.schoolYearMinDate
        ? moment(this.schoolYearMinDate).isoWeekday() <= 1
          ? moment(this.schoolYearMinDate).isoWeekday(1)
          : moment(this.schoolYearMinDate).add(1, 'week').isoWeekday(1)
        : moment().startOf('isoWeek').add(1, 'week')
      let fromTime = firstMonday.set({ hour: 6, minute: 0 })
      let toTime = moment(firstMonday).isoWeekday(5).set({ hour: 16, minute: 0 })
      this.form = {
        title: 'Lejrskole',
        fromTime: fromTime,
        toTime: toTime,
        klassCalendarIds: [],
        userCalendarIds: [],
        existingHours: {},
        useAdditionalTasks: true
      }
      this.isModal = true
      this.$nextTick(() => {
        if (this.$refs.titleInput) this.$refs.titleInput.focus()
      })
    },
    openEditModal (camp) {
      this.theEditCamp = camp
      const ids = camp.calendar_ids || []
      const klassIds = []
      const userIds = []
      ids.forEach(id => {
        const cal = this.allCalendarsInHash[id]
        if (cal && cal.type === 'user') {
          userIds.push(id)
        } else {
          klassIds.push(id)
        }
      })
      const existingHoursMap = {}
      if (camp.existing_hours) {
        camp.existing_hours.forEach(entry => {
          if (entry.calendar_id != null && entry.hours != null) {
            existingHoursMap[entry.calendar_id] = entry.hours
          }
        })
      }
      this.form = {
        title: camp.title,
        fromTime: camp.from_time ? moment(camp.from_time) : moment(),
        toTime: camp.to_time ? moment(camp.to_time) : moment(),
        klassCalendarIds: klassIds,
        userCalendarIds: userIds,
        existingHours: existingHoursMap,
        useAdditionalTasks: !!camp.use_additional_tasks
      }
      this.scheduledHours = {}
      this.isModal = true
      this.fetchScheduledHours()
    },
    closeModal () {
      this.isModal = false
      this.theEditCamp = null
    },
    onFromDateChanged (date) {
      const hours = moment(this.form.fromTime).hours()
      const minutes = moment(this.form.fromTime).minutes()
      const newFrom = moment(date).set({ hour: hours, minute: minutes })
      this.form.fromTime = newFrom
      if (moment(newFrom).startOf('day').isAfter(moment(this.form.toTime).startOf('day'))) {
        this.form.toTime = moment(newFrom).set({ hour: moment(this.form.toTime).hours(), minute: moment(this.form.toTime).minutes() })
      }
      this.fetchScheduledHoursIfNeeded()
    },
    onToDateChanged (date) {
      const hours = moment(this.form.toTime).hours()
      const minutes = moment(this.form.toTime).minutes()
      const newTo = moment(date).set({ hour: hours, minute: minutes })
      this.form.toTime = newTo
      if (moment(newTo).startOf('day').isBefore(moment(this.form.fromTime).startOf('day'))) {
        this.form.fromTime = moment(newTo).subtract(1, 'day').set({ hour: moment(this.form.fromTime).hours(), minute: moment(this.form.fromTime).minutes() })
      }
      this.fetchScheduledHoursIfNeeded()
    },
    fetchScheduledHoursIfNeeded () {
      if (this.form.userCalendarIds.length > 0) {
        this.fetchScheduledHours()
      }
    },
    onStartTimeInput (val) {
      const parsed = moment(val, 'LT')
      if (!parsed.isValid()) return
      const hours = parsed.hours()
      const minutes = parsed.minutes()
      this.form.fromTime = moment(this.form.fromTime).set({ hour: hours, minute: minutes })
    },
    onEndTimeInput (val) {
      const parsed = moment(val, 'LT')
      if (!parsed.isValid()) return
      const hours = parsed.hours()
      const minutes = parsed.minutes()
      this.form.toTime = moment(this.form.toTime).set({ hour: hours, minute: minutes })
    },
    setSelectedKlasses (klasses) {
      this.form.klassCalendarIds = klasses.map(k => k.id)
    },
    setSelectedUsers (users) {
      const newIds = users.map(u => u.id)
      const newExistingHours = {}
      newIds.forEach(id => {
        newExistingHours[id] = this.form.existingHours[id] || 0
      })
      this.form.userCalendarIds = newIds
      this.form.existingHours = newExistingHours
      this.fetchScheduledHours()
    },
    fetchScheduledHours () {
      const start = moment(this.form.fromTime).format('YYYY-MM-DD')
      const end = moment(this.form.toTime).format('YYYY-MM-DD')
      this.form.userCalendarIds.forEach(calendarId => {
        docendo.hoursCountForCalendar(this.schoolId, calendarId, start, end, response => {
          const rows = JSON.parse(response)
          const totalRow = rows.find(row => row[0] === null && row[1] === null && row[2] === null)
          const totalMinutes = totalRow && totalRow[3] ? totalRow[3] : 0

          const campTitle = this.form.title
          const campRow = campTitle
            ? rows.find(row => row[0] === 'teaching' && row[1] === 'activity' && row[2] === campTitle)
            : null
          const campMinutes = campRow && campRow[3] ? campRow[3] : 0

          this.$set(this.scheduledHours, calendarId, totalMinutes - campMinutes)
        }, () => {
          this.$set(this.scheduledHours, calendarId, 0)
        })
      })
    },
    formatMinutesToHours (minutes) {
      if (!minutes) return '0'
      const hours = Math.round((minutes / 60) * 100) / 100
      return hours
    },
    saveCamp () {
      if (this.isSaving) return
      this.isSaving = true

      const fromTime = moment(this.form.fromTime).format('YYYY-MM-DD HH:mm')
      const toTime = moment(this.form.toTime).format('YYYY-MM-DD HH:mm')
      const calendarIds = this.form.klassCalendarIds.concat(this.form.userCalendarIds)
      const existingHours = Object.keys(this.form.existingHours)
        .map(id => ({ calendar_id: parseInt(id), hours: this.form.existingHours[id] || 0 }))

      if (this.theEditCamp) {
        docendo.schoolCampsUpdate(
          this.schoolId,
          this.theEditCamp.id,
          this.activeSchoolYear.id,
          fromTime,
          toTime,
          this.form.title,
          calendarIds,
          existingHours,
          this.form.useAdditionalTasks,
          () => {
            eventbus.toast = { text: this.i18n[this.locale].updated, success: true }
            this.isSaving = false
            this.closeModal()
            this.readCamps()
            this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
          },
          () => {
            eventbus.toast = { text: this.i18n[this.locale].something_went_wrong, success: false }
            this.isSaving = false
          }
        )
      } else {
        docendo.schoolCampsCreate(
          this.schoolId,
          this.activeSchoolYear.id,
          fromTime,
          toTime,
          this.form.title,
          calendarIds,
          existingHours,
          this.form.useAdditionalTasks,
          () => {
            eventbus.toast = { text: this.i18n[this.locale].created, success: true }
            this.isSaving = false
            this.closeModal()
            this.readCamps()
            this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
            this.$store.dispatch('trackEvent', 'subjectsDistribution_camp_created')
          },
          () => {
            eventbus.toast = { text: this.i18n[this.locale].something_went_wrong, success: false }
            this.isSaving = false
          }
        )
      }
    },
    deleteCamp () {
      if (this.isDeleting || !this.theDeleteCamp) return
      this.isDeleting = true
      const campToDelete = this.theDeleteCamp
      docendo.schoolCampsDelete(
        this.schoolId,
        this.activeSchoolYear.id,
        campToDelete.id,
        () => {
          eventbus.toast = { text: this.i18n[this.locale].deleted, success: true }
          this.isDeleting = false
          this.theDeleteCamp = null
          if (this.theEditCamp && this.theEditCamp.id === campToDelete.id) {
            this.closeModal()
          }
          this.readCamps()
          this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
        },
        () => {
          eventbus.toast = { text: this.i18n[this.locale].something_went_wrong, success: false }
          this.isDeleting = false
        }
      )
    }
  },
  mounted () {
    this.readCamps()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.school-camps {
  padding: 1rem 0;
}

.school-camps__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.school-camps__header h3 {
  margin: 0;
}

.school-camps__empty {
  padding: 2rem;
  text-align: center;
  color: #999;
}

.camp-row {
  cursor: pointer;
  transition: background-color 0.15s;
}

.td-title {
  font-weight: 600;
}

.td-datetime {
  white-space: nowrap;
}

.td-calendars {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.th-actions,
.td-actions {
  width: 80px;
  text-align: right;
}

.td-hours-col {
  max-width: 80px;
  white-space: nowrap;
}

.do-bttn--danger {
  color: var(--danger);
}

.camp-create__header {
  padding: 1rem 2rem;
  background: #ffffff;
  border-bottom: 1px solid var(--border-color);
  border-radius: 4px 4px 0 0;
}

.camp-create__guide {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--primary-color, #2a7ae2);
  text-decoration: none;
  font-size: 0.875rem;
}

.camp-create__guide:hover {
  text-decoration: underline;
}

.camp-create__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 8px;
  font-size: 15px;
  cursor: pointer;
  transition: color 0.25s, background-color 0.25s;
}

.camp-create__modal {
  min-width: 550px;
  border-radius: 4px;
  transition: max-width 0.2s ease;
}

.camp-create__grid {
  display: flex;
  gap: 2rem;
}

.camp-create__form {
  flex: 1;
  min-width: 0;
  max-width: 500px;
}

.camp-create__sidebar {
  width: 280px;
  flex-shrink: 0;
  border-left: 1px solid var(--border-color);
  padding-left: 2rem;
}

.camp-create__sidebar-desc {
  font-size: 0.8rem;
  color: #a2a3a6;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
  padding: .25rem .5rem;
    display: inline-block;
    background: #fefce8;
    color: #854d0f;
    border: 1px solid #f4e6c0;
    border-radius: 4px;
}

.camp-create__sidebar-header {
  letter-spacing: .075rem;
  text-transform: uppercase;
  font-size: 0.85rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #a2a3a6;
  margin-bottom: 6px;
}

.th-hours {
  width: 80px;
  text-align: center !important;
}

.td-hours {
  width: 80px;
  text-align: center;
}

.td-hours__input {
  width: 70px;
  text-align: center;
  padding: 0.25rem 0.4rem;
  font-size: 0.9rem;
}

.camp-create__body {
  padding: 1rem 2rem;
  max-height: calc(80vh);
  overflow-y: auto;
  border-radius: 4px;
}

.camp-create__form .input-group {
  margin-bottom: 1.5rem;
  flex: 1;
}

.camp-create__form .input-group:last-child {
  margin-right: 0;
}

.input-group label {
  letter-spacing: .075rem;
  text-transform: uppercase;
  font-size: 0.85rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #a2a3a6;
  margin-bottom: 6px;
}

.input-group__flex {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.input-group__submit {
  display: flex;
  justify-content: space-between;
  background: #fff;
  margin: 1rem -2rem -1rem -2rem;
  padding: 1rem 2rem;
  border-top: 1px solid var(--border-color);
}

.input-group__submit__left {
  display: flex;
  align-items: center;
}

.input-group__submit__right {
  display: flex;
  align-items: center;
}

.d-input {
  background-color: #fff;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
  min-height: 32px;
}

.date-field {
  position: relative;
  display: flex;
  align-items: center;
}

.marg-1-right {
  margin-right: 1rem;
}

.bttn--warning {
  color: var(--danger);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
}

.bttn--warning:hover {
  opacity: 0.7;
}

.date-time-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.date-time-row__date {
  flex: 1;
}

.camp-toggle {
  display: inline-flex;
  flex-direction: column;
  border-radius: 4px;
  width: 100%;
}

.camp-toggle__option {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  line-height: 16px;
  transition: color 0.25s;
  cursor: pointer;
  padding: 1rem;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-width: 1px 1px 0 1px;
}

.camp-toggle__option:first-child {
  border-radius: 4px 4px 0 0;
}

.camp-toggle__option:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 1px solid #e5e7eb;
}

.camp-toggle__option--selected + .camp-toggle__option {
  border-top: none;
}

.camp-toggle__option--selected,
.camp-toggle .camp-toggle__option--selected:last-child {
  background: #eff2ff;
  border: 1px solid #c8d2fe;
}

.camp-toggle__option > input[type="radio"] {
  width: auto;
  padding-right: 8px;
}

.camp-toggle__option > input[type="radio"]:checked + label {
  color: var(--dark-blue);
}

.camp-toggle__option label {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  font-size: 12px;
  cursor: pointer;
}

.camp-toggle__option:hover label {
  color: var(--dark-blue);
}

.camp-toggle__option-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.camp-toggle__option-text .bold + span {
  color: #737373;
}
</style>



// WEBPACK FOOTER //
// SchoolCamps.vue?392cb553